import { FC } from 'react';
import { useLocation } from 'react-router-dom';
import { UPProductProvider } from '../../providers/UPProductProvider/UPProductProvider';
import CommunicationTracks from '../CommunicationTracks';
import CommunicationDetails from '../CommunicationDetails';
import CommunicationTracksBulkImport from '../CommunicationTracksBulkImport';

interface CommunicationWrapperProps {}
export const CommunicationWrapper: FC<CommunicationWrapperProps> = (props) => {
  const location = useLocation();
  if (location.pathname === '/communication-tracks') {
    return (
      <UPProductProvider>
        <CommunicationTracks />
      </UPProductProvider>
    );
  }

  if (location.pathname === '/communication-tracks/bulk-import') {
    return (
      <UPProductProvider>
        <CommunicationTracksBulkImport />
      </UPProductProvider>
    );
  }

  return (
    <UPProductProvider>
      <CommunicationDetails />
    </UPProductProvider>
  );
};

export default CommunicationWrapper;
